// Check if mobile device
function isTouchDevice() {
	return 'ontouchstart' in document.documentElement;
}
  
(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();
	var documentHeight = $(document).height();

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	if(isTouchDevice()){
		var navbarHeight = 0;
		var bookHeight = 0;
	} else {
		var navbarHeight = 700;
		var bookHeight = 67;
		var hidePhone = 100;
	}	

	$(window).scroll(function(event){
	    didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 250);

	function hasScrolled() {
	    var st = $(this).scrollTop();
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;

	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
					$('html').addClass('scrolled');
					$('html').removeClass('visible');
	    } else {
	        // Scroll Up
	        if(st < lastScrollTop) {
						$('html').addClass('scrolled');
						$('html').addClass('visible');
	        }
			if (st < navbarHeight) {
				$('html').removeClass('scrolled');
				$('html').removeClass('visible');
			}
	    }

		// Scroll class for booking menu
	    if (st > lastScrollTop && st > bookHeight){
	        // Scroll Down
					$('html').addClass('booking-show');
	    } else {
	        // Scroll Up
	        if(st < lastScrollTop) {
						$('html').addClass('booking-show');
	        }
			if (st < bookHeight) {
				$('html').removeClass('booking-show');
			}
		}
		
		// Hide phonenumber
	    if (st > lastScrollTop && st > hidePhone){
	        // Scroll Down
					$('html').addClass('hide-phone');
	    } else {
	        // Scroll Up
	        if(st < lastScrollTop) {
						$('html').addClass('hide-phone');
	        }
			if (st < hidePhone) {
				$('html').removeClass('hide-phone');
			}
	    }
		lastScrollTop = st;
	}


	/* Document ready functions */
	$(document).ready(function (){



	});

	$(window).resize(function () {



    });
    // Add back to top button
    if($('.submenu-section .cat-item').length ){
        var li = document.createElement('li');
        li.className = 'menu-item to-top';
        var link = document.createElement('a');
        link.appendChild(document.createTextNode(''));
        link.href = "#site-header";
        li.appendChild(link);

        document.querySelector('.primary-child-navigation .menu').appendChild(li);
    }

})(jQuery);

//# sourceMappingURL=header-scroll.js.map
